export default __webpack_public_path__ + "static/media/building.6d20d8ae.svg";